import { EPromoType, IPromoInfoSchema } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export const getSubtitle = (promo: IPromoInfoSchema): string | null | undefined => {
  const isCianMortgage = promo.promoType === EPromoType.CianMortgage;

  return isCianMortgage ? null : promo.end;
};
